import { z } from 'zod'

import { MarketingType } from '../constants/marketing'

export const marketingAdminScopeSchema = z.object({
  type: z.literal(MarketingType.ADMIN),
  organization: z.null().optional(),
  venue: z.null().optional(),
})

export const marketingOrganizationScopeSchema = z.object({
  type: z.literal(MarketingType.ORGANIZATION),
  organization: z.string().min(1),
  venue: z.string().min(1).nullish(),
})

export const marketingEntityScopeSchema = z.discriminatedUnion('type', [
  marketingAdminScopeSchema,
  marketingOrganizationScopeSchema,
])

export const validateMarketingEntityScope = (
  data: {
    type: MarketingType
    organization?: string | null
    venue?: string | null
  },
  ctx: z.RefinementCtx
): void => {
  const parsed = marketingEntityScopeSchema.safeParse(data)
  if (parsed.success) return

  for (const issue of parsed.error.issues) {
    ctx.addIssue(issue)
  }
}
